import { getContext } from '@picsart/miniapps-sdk';
import { POLLING_TRIES, POLLING_INTERVAL, TaskItemStatus, APP_API_URL } from '../constants';
import { TaskItem, Task } from '../types';
import NetworkError from './networkError';

async function getTaskResult(serviceConfig: any, promptId: string, taskId: string, triesLeft = POLLING_TRIES): Promise<TaskItem[]> {
  if (triesLeft <= 0) {
    throw new NetworkError('We’re sorry, the connection has timed out');
  }

  const { t2b_service_url: T2BServiceURL, t2b_ai_service_path: T2BAIServicePath } = serviceConfig;

  const task: Task = await getContext()
    .utils.api.fetch(`${APP_API_URL}${T2BServiceURL}`, {
      headers: {
        Accept: 'application/json',
        platform: 'web',
        'prompt-id': promptId,
        taskId,
        aiBaseServiceUrl: T2BAIServicePath,
        aiTouchPoint: 'ai_text_to_bg',
      },
    })
    .then(res => Promise.all([res, res.json()]))
    .then(([res, body]) => {
      return [res, body.response];
    })
    .then(([res, response]) => {
      if (!res.ok) {
        throw new NetworkError('Something went wrong. Please try again later');
      }

      return response;
    });

  if (task.status !== TaskItemStatus.DONE) {
    return new Promise(res => {
      setTimeout(() => {
        res(getTaskResult(serviceConfig, promptId, taskId, triesLeft - 1));
      }, POLLING_INTERVAL);
    });
  }

  return task.data;
}

export default getTaskResult;
